import { AxiosRequestConfig } from 'axios'
import createAPIClient from '../services/apiClient'
import { AlertPhone, AlertPhoneInput, UserAlertRule, UserAlertRuleInput } from '../types'

const api = createAPIClient('/v2')

export async function getAlertPhones(
  query: { projectId: number },
  config?: AxiosRequestConfig
): Promise<AlertPhone[]> {
  const response = await api.get('/alert-phones', { ...config, params: query })

  return response.data
}

export async function createAlertPhone(
  data: AlertPhoneInput,
  config?: AxiosRequestConfig
): Promise<AlertPhone> {
  const response = await api.post('/alert-phones', data, config)

  return response.data
}

export async function deleteAlertPhone(id: number, config?: AxiosRequestConfig): Promise<void> {
  await api.delete(`/alert-phones/${id}`, {
    ...config
  })
}

export async function sendAlertPhoneVerificationCode(
  id: number,
  config?: AxiosRequestConfig
): Promise<void> {
  await api.post(`/alert-phones/${id}/verify/code`, {}, config)
}

export async function verifyAlertPhone(
  id: number,
  code: string,
  config?: AxiosRequestConfig
): Promise<AlertPhone> {
  const response = await api.post(`/alert-phones/${id}/verify/confirm`, { code }, config)
  return response.data
}

export async function getAlertPhoneAlertRules(
  id: number,
  config?: AxiosRequestConfig
): Promise<UserAlertRule[]> {
  const response = await api.get(`/alert-phones/${id}/alert-rules`, config)
  return response.data
}

export async function updateAlertPhoneAlertRules(
  id: number,
  alertRules: UserAlertRuleInput[],
  config?: AxiosRequestConfig
): Promise<UserAlertRule[]> {
  const response = await api.put(`/alert-phones/${id}/alert-rules`, alertRules, config)
  return response.data
}
